<div *ngIf="isFilteredBySkill" class="skill-filter">
   <fa-icon [icon]="statusBarFilterIcon"></fa-icon>
   <label> {{ filteredGroupTranslationValue | translate }} </label>
   <samweb-skill-short-info
      [skills]="filteredSkill?.skills"
      [skillConfiguration]="filteredSkill?.skillConfiguration"
   ></samweb-skill-short-info>
</div>
